import React, { useState, useCallback } from 'react';
import { 
  Stack,
  Divider,
  Input, 
  Button, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast
} from '@chakra-ui/react'
import { BiMessageSquareError } from 'react-icons/bi';
import { postSuggestion } from "src/api";
import { useUser } from 'src/context';
import { getCurrentTimeString } from "utils";

const GamePriceInfo = props => {
  const { unitPrice, priceTable, gameId, title } = props;
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isPosting, setIsPosting] = useState(false);

  const { 
    isLogin, 
    user: { email } 
  } = useUser();

  const toast = useToast()

  const handleSuggestionClick = () => {
    setIsOpenDialog(true);
  };

  const handleSuggestionClose = () => {
    setIsOpenDialog(false);
  };

  const handleSuggestionSend = useCallback(async (content) => {
    const currentTime = new Date();

    const postContent = {
      content,
      gameId,
      title,
      reporterEmail: isLogin ? email : "",
      reportTime: getCurrentTimeString(currentTime),
    }

    setIsPosting(true);
    
    try {
      await postSuggestion(postContent);
    } catch (err) {
      console.log(err);
    } finally {
      setIsPosting(false);
      setIsOpenDialog(false);

      toast({
        title: "感謝您的補充",
        description: "我們會盡快確認資訊來源並且更新此頁內容。",
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      })
    }
  }, [gameId, title, isLogin])

  return (
    <>
      <div className='mb-6 lg:mb-8'>
        <h4 className='mb-2 pl-2 text-lg leading-none font-bold border-l-4 border-primary'>
          價格參考
        </h4>
        <Divider />
        <div className='py-2 bg-white rounded-sm shadow-sm'>
          <p className='mb-2 pl-4 leading-normal text-sm lg:text-base whitespace-pre-wrap'>
            {priceTable ? priceTable : `定價：$${unitPrice} / 人`}
          </p>
          <Stack direction={{ base: 'column', md: 'row'}} justify='center' align='center' spacing='1'>
            <p className='text-sm text-center  text-gray-700 font-semibold'>
              最新活動優惠請洽工作室
            </p>
            <Button 
              variant='ghost'
              size='sm'
              rightIcon={<BiMessageSquareError />}
              onClick={handleSuggestionClick}
            >
              本頁資訊若有誤請點此回報
            </Button>
          </Stack>
        </div>
      </div>
      <SuggestionForm 
        isOpen={isOpenDialog}
        isPosting={isPosting}
        onSend={handleSuggestionSend}
        onClose={handleSuggestionClose}
      />
    </>
  )
}

const SuggestionForm = ({ isOpen, onSend, onClose, isPosting }) => {
  const [content, setContent] = useState("");

  const handleContentChange = e => {
    setContent(e.target.value);
  };

  const handleSubmit = () => {
    onSend(content);
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>資訊更正建議</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <p>我們致力於提供最新且正確的資訊給使用者，若此頁面的資訊過時或者含有誤導內容，歡迎提供正確的資訊來源或者內容。</p>
          <Input 
            variant='flushed'
            placeholder="請概述本頁需要更正的內容"
            value={content}
            onChange={handleContentChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button 
            variant='outline'
            onClick={onClose} 
            isDisabled={isPosting}
          >
            取消
          </Button>
          <Button 
            variant='solid'
            color='blue'
            onClick={handleSubmit} 
            isDisabled={isPosting || content.length < 3}
          >
            送出
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};

export default GamePriceInfo;